import { CplaceSingleSelectControlChange, CplaceSingleSelectControlParameters, Option, OptionGroup } from '../../api/model/models';
import { ControlChangeHandler } from '../../controls';
import { mockControlIdentity, mockControlStateSharedData } from './controls.shared';

export const mockCplaceSingleSelectControlOptions: Array<Option> = [
  {
    label: 'No Localized 2',
    value: 'value-1',
    icon: 'fa fa-tree',
  },
  {
    label: 'Optional Localized',
    value: 'value-2',
    icon: 'fa fa-tree',
  },
  {
    label: 'Mandatory Localized',
    value: 'value-3',
    icon: 'fa fa-tree',
  },
];

export const mockCplaceSingleSelectControlOptionGroups: Array<OptionGroup> = [
  {
    label: 'USA',
    icon: 'fa fa-flag',
    value: 'value-1',
    options: [
      { label: 'Chicago', value: 'Chicago', icon: 'fa fa-home' },
      { label: 'Los Angeles', value: 'Los Angeles', icon: 'fa fa-home' },
      { label: 'New York', value: 'New York', icon: 'fa fa-home' },
      { label: 'San Francisco', value: 'San Francisco', icon: 'fa fa-home' },
    ],
  },
  {
    label: 'Japan',
    icon: 'fa fa-flag',
    value: 'value-2',
    options: [
      { label: 'Kyoto', value: 'Kyoto', icon: 'fa fa-home' },
      { label: 'Osaka', value: 'Osaka', icon: 'fa fa-home' },
      { label: 'Tokyo', value: 'Tokyo', icon: 'fa fa-home' },
      { label: 'Yokohama', value: 'Yokohama', icon: 'fa fa-home' },
    ],
  },
  {
    label: 'Germany',
    icon: 'fa fa-flag',
    value: 'value-3',
    options: [
      { label: 'Berlin', value: 'Berlin', icon: 'fa fa-home' },
      { label: 'Frankfurt', value: 'Frankfurt', icon: 'fa fa-home' },
      { label: 'Hamburg', value: 'Hamburg', icon: 'fa fa-home' },
      { label: 'Munich', value: 'Munich', icon: 'fa fa-home' },
    ],
  },
];

export const mockCplaceSingleSelectControlControlParams: CplaceSingleSelectControlParameters = {
  componentName: 'CplaceSingleSelectControlComponent',
  value: mockCplaceSingleSelectControlOptionGroups[0].options[0].value,
  options: mockCplaceSingleSelectControlOptions,
  optionGroups: mockCplaceSingleSelectControlOptionGroups,
  clearable: true,
};

export const mockCplaceSingleSelectControlControlState = {
  ...mockControlStateSharedData,
  identity: mockControlIdentity,
  controlParameters: mockCplaceSingleSelectControlControlParams,
  clearable: true,
};

export const mockCplaceSingleSelectControlChangeHandler: ControlChangeHandler<
  CplaceSingleSelectControlChange,
  CplaceSingleSelectControlParameters
> = (controlParameters, controlChange) => {
  return {
    ...controlParameters,
    value: controlChange.value,
  };
};
